import { useUserContext } from "../../../user/use-user-context";
import { useAssetCollectionContext } from "../../AssetCollection/asset-collection-context";

export function useShouldShowSendLinkAction() {
  const { isAuthenticated } = useUserContext();
  const assetCollectionContext = useAssetCollectionContext();
  return isAuthenticated && assetCollectionContext === "no-ac-context";
}
